// extracted by mini-css-extract-plugin
export var grid = "FlashCardGrid-module--grid--f5121";